import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const RegulatorSectionStyle = withTheme(styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  max-width: 1182px;
  margin: 80px auto;
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    margin: 80px 24px;
  }

  ${(props: any) => props.theme.breakpoints.down('md')} {
    margin: 48px 24px;
    .topic {
      font-size: 24px;
      line-height: 24px;
    }
  }
`);

export default RegulatorSectionStyle;
